import { useState } from "react";
import StarIcon from "../../../components/ui/StarIcon";
import ShopModal from "./ShopModal";
import { KIND_STYLES } from "./kindStyles";
import * as styled from "./Shop.styled";

// Форма «Подарунок другу»: ім'я та телефон нової людини
function GiftForm({ item, onSubmit, onClose }) {
  const [friendName, setFriendName] = useState("");
  const [friendPhone, setFriendPhone] = useState("");
  const [error, setError] = useState(null);
  const [sending, setSending] = useState(false);
  const { Icon, tint, color } = KIND_STYLES.gift_friend;

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!friendName.trim() || friendPhone.replace(/\D/g, "").length < 9) {
      setError("Вкажи ім'я та номер телефону друга");
      return;
    }
    setSending(true);
    setError(null);
    try {
      await onSubmit({ friendName, friendPhone });
    } catch (submitError) {
      setError(submitError.message);
      setSending(false);
    }
  };

  return (
    <ShopModal onClose={onClose}>
      <styled.ModalIcon $tint={tint} $color={color}>
        <Icon size={32} />
      </styled.ModalIcon>
      <styled.ModalTitle>{item.title}</styled.ModalTitle>
      <styled.ModalText>
        Ми зателефонуємо другу й запишемо на уроки. Подарувати можна людині, яка ще не навчалася в Speaksy.
      </styled.ModalText>
      <styled.Form onSubmit={handleSubmit}>
        <styled.Input
          placeholder="Ім'я друга"
          value={friendName}
          onChange={(event) => setFriendName(event.target.value)}
        />
        <styled.Input
          placeholder="+380 67 123 45 67"
          type="tel"
          inputMode="tel"
          value={friendPhone}
          onChange={(event) => setFriendPhone(event.target.value)}
        />
        {error && <styled.FormError>{error}</styled.FormError>}
        <styled.PrimaryButton type="submit" disabled={sending}>
          {sending ? (
            "Оформлюємо..."
          ) : (
            <>
              Подарувати за {item.priceStars} <StarIcon size={18} />
            </>
          )}
        </styled.PrimaryButton>
      </styled.Form>
    </ShopModal>
  );
}

export default GiftForm;
